import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { APP_SELLER_ROUTE } from '~shared/constants';
import { Money } from '~shared/models';
import { OrderLine } from '../../models';
import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { debounceTime, share } from 'rxjs/operators';
import { ApplicationEventService } from '~shared/modules/application-event/services/application-event.service';
import { OrderHistoryApplicationEvent, } from '~shared/modules/application-event/models';
import { GaTrackingEventCategory, GaTrackingEventName } from '~shared/modules/ga-tracking/constants';
import { OrderHistoryEventActionType } from '~shared/modules/application-event/constants';
import { OrdersHistoryService } from '../../services/orders-history.service';
import { APP_PRODUCT_ROUTE } from '~app/modules/account/modules/orders-history/constants/routes.constant';
import { environment } from '~env/environment';

@Component({
  selector: 'app-order-line-vas-item',
  templateUrl: './order-line-vas-item.component.html',
  styleUrls: ['./order-line-vas-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderLineVasItemComponent implements OnInit, OnDestroy {
  @Input() orderLine: OrderLine;
  @Input() isEntrepreneur: boolean;
  @Input() isLastOrderLine: boolean;

  APP_PRODUCT_ROUTE = APP_PRODUCT_ROUTE;

  public unitPrice: Money;
  public price: Money;
  public totalPriceGross: Money;
  public discount: Money;
  public grandTotal: Money;

  public readonly sellerRoute = `/${APP_SELLER_ROUTE}`;

  private destroy$ = new Subject<void>();
  settingIconUrl = `${environment.cdnBaseUrl()}/images/icon-installation-service.svg`;

  constructor(
    private cd: ChangeDetectorRef,
    private applicationEventService: ApplicationEventService,
    private ordersHistoryService: OrdersHistoryService,
    ) {
  }

  ngOnInit() {
    this.setProductData();
    this.subscribeToWindowResize();
  }

  public get isDiscountApplied(): boolean {
    const discount = +this.orderLine?.discount.amount;
    return discount > 0;
  }

  // Used to show tooltip on product name when name is truncated
  private subscribeToWindowResize() {
    const resizeDebounceTime = 250;
    fromEvent(window, 'resize')
      .pipe(
        debounceTime(resizeDebounceTime),
        share(),
        takeUntil(this.destroy$),
      )
      .subscribe(() => this.cd.detectChanges());
  }

  public ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  setProductData(): void {
    const { unitPrice, price, totalPriceGross, discount, grandTotal } = this.orderLine;
    this.unitPrice = unitPrice;
    this.price = price;
    this.totalPriceGross = totalPriceGross;
    this.discount = discount;
    this.grandTotal = grandTotal;
  }

  public navigateToSellerClicked() {
    this.applicationEventService.publish(new OrderHistoryApplicationEvent({
      event: GaTrackingEventName.NavigateToSeller,
      action: OrderHistoryEventActionType.NavigateToSeller,
      label: this.orderLine.seller.shopName,
      category: GaTrackingEventCategory.Navigation,
    }));
  }

  public createSupportTicket(orderLineId: string): void {
    this.ordersHistoryService.createSupportTicket(orderLineId);
    this.applicationEventService.publish(new OrderHistoryApplicationEvent({
      event: GaTrackingEventName.ContactSeller,
      action: OrderHistoryEventActionType.ContactSeller,
      label: 'Order History Create Support Ticket',
    }));
  }

}
